<template>
  <el-dialog
    class="radish-dia"
    title="面试反馈"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="round">
      <span style="margin-right:3px">选择面试：</span>
      <el-select v-if="mianReady" v-model="interId" filterable size="mini" @change="changeInt">
        <el-option v-for="item in interviews" :key="item._id" :label="item.round + '面'" :value="item._id"> </el-option>
      </el-select>
    </div>
    <div class="flex-row">
      <div class="col-1">
        <p>推荐顾问：{{ showInterview['顾问'] }}</p>
      </div>
      <div class="col-1">
        <p><el-radio v-if="showInterview['结果'] !== '淘汰'" v-model="radio" label="1">通过</el-radio></p>
        <p class="flex-row item-center">
          <el-radio v-model="radio" class="mr10" label="2">淘汰</el-radio>
          <el-input v-model="showInterview['淘汰理由']" size="mini" type="textarea" autosize />
        </p>
      </div>
    </div>
    <div class="note">
      <p>客户反馈</p>
      <el-input v-model="showInterview['客户备注']" size="mini" type="textarea" autosize />
    </div>
    <div v-for="(_tagGroup, _i) in feedbackTags" :key="_i" class="pd-10">
      <div>{{ _tagGroup.label }}</div>
      <div v-if="_tagGroup.key === 'other'">
        <el-tag
          v-for="_tag in _tagGroup.checkList"
          :key="_tag"
          closable
          size="small"
          @close="removeTag(_tag, 'feedbackTags')"
        >
          {{ _tag }}
        </el-tag>
        <el-input
          v-if="inputVisible === 'radish'"
          ref="saveTagInput"
          v-model="inputValue"
          class="input-new-tag"
          size="small"
          @keyup.enter.native="handleInputConfirm('feedbackTags')"
          @blur="handleInputConfirm('feedbackTags')"
        />
        <el-button v-else class="button-new-tag" size="small" @click="showInput('radish')">+ New Tag</el-button>
      </div>
      <el-checkbox-group v-else v-model="_tagGroup.checkList" class="flex-row flex-wrap">
        <el-checkbox v-for="_tag in _tagGroup.children" :key="_tag" :label="_tag" class="check-item mr10" />
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { tags } from '../../../communicate'

export default {
  data: function() {
    return {
      dialogVisible: false,
      showInterview: {},
      interviews: [],
      interId: '',
      mianReady: false,
      radio: '1',
      tags: [],
      feedbackTags: [],
      inputVisible: undefined,
      inputValue: '',
    }
  },
  methods: {
    show: async function(row, pid) {
      this.showInterview = {}
      const res = await app.service('radish').findInterview({ rid: row.rid, pid: pid })
      if (res.data.length == 0) {
        this.$alert('还没有安排面试', { showClose: false })
        return
      }
      this.interviews = res.data
      const interview = res.data[0]
      this.interId = interview._id
      this.showInterview = interview
      this.init()
      this.mianReady = true
      this.dialogVisible = true
    },
    init() {
      this.radio = this.showInterview['结果'] === '淘汰' ? '2' : '1'
      this.feedbackTags = this.parseTags(this.showInterview['客户反馈'])
    },
    parseTags(data = {}) {
      const result = _.cloneDeep(tags)
      result.map(tagGroup => {
        tagGroup.checkList = data[tagGroup.key] || []
      })
      return result
    },
    removeTag(tag, field) {
      const _tags = this[field]
      _tags.map(tagGroup => {
        if (tagGroup.key === 'other') {
          const children = tagGroup.children
          children.splice(children.indexOf(tag), 1)
        }
      })
    },
    showInput(index) {
      this.inputVisible = index
      this.$nextTick(_ => {
        this.$refs.saveTagInput && this.$refs.saveTagInput[0].$refs.input.focus()
      })
    },
    handleInputConfirm(field) {
      const inputValue = this.inputValue
      if (inputValue) {
        const _tags = this[field]
        _tags.map(tagGroup => {
          if (tagGroup.key === 'other') {
            tagGroup.checkList.push(inputValue)
          }
        })
      }
      this.inputVisible = undefined
      this.inputValue = ''
    },
    changeInt: function() {
      const intArr = this.interviews.filter(i => i._id == this.interId)
      this.showInterview = intArr[0]
      this.init()
    },
    handleConfirm: async function() {
      const { feedbackTags, radio, showInterview } = this
      const radishParam = {}
      feedbackTags.map(tagGroup => {
        radishParam[tagGroup.key] = tagGroup.checkList
      })
      if (radio === '2') {
        app.service('radish').eliminate({
          rid: showInterview.rid,
          pid: showInterview.pid,
          reason: showInterview['淘汰理由'],
        })
      }
      const res = await app.service('radish').modifyInterview({
        _id: showInterview._id,
        data: {
          客户反馈: radishParam,
          客户备注: showInterview['客户备注'],
        },
      })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '反馈成功' })
      } else {
        this.$message.error(res.msg)
      }
      this.dialogVisible = false
    },
  },
}
</script>
